;(function () {
	const normalizePath = (pathname) => {
		if (!pathname || pathname === '/') return '/'
		return pathname.replace(/\/+$/, '')
	}

	const parseHref = (href) => {
		try {
			return new URL(href, window.location.href)
		} catch {
			return null
		}
	}

	const getHashId = (url) => {
		if (!url || !url.hash || url.hash === '#') return ''
		try {
			return decodeURIComponent(url.hash.slice(1))
		} catch {
			return url.hash.slice(1)
		}
	}

	const findHashTarget = (id) => {
		if (!id) return null
		return document.getElementById(id)
	}

	const scrollToTarget = (target, behavior = 'smooth') => {
		if (!target) return
		target.scrollIntoView({ behavior, block: 'start' })
	}

	const isSamePage = (url) => {
		if (!url) return false
		return (
			url.origin === window.location.origin &&
			normalizePath(url.pathname) === normalizePath(window.location.pathname)
		)
	}

	const isCurrentTrail = (url) => {
		if (!url || url.origin !== window.location.origin) return false
		const linkPath = normalizePath(url.pathname)
		const currentPath = normalizePath(window.location.pathname)
		if (linkPath === currentPath) return true
		return currentPath.startsWith(`${linkPath}/products/`)
	}

	const expandAccordion = (accordion) => {
		accordion.open = true
		accordion.classList.add('is-open')
	}

	const openCurrentAccordions = (root) => {
		root.querySelectorAll('.dw-menu__link[href]').forEach((anchor) => {
			const url = parseHref(anchor.getAttribute('href'))
			if (!isCurrentTrail(url)) return

			let accordion = anchor.closest('.dw-menu__accordion')
			while (accordion) {
				expandAccordion(accordion)
				accordion = accordion.parentElement?.closest('.dw-menu__accordion')
			}
		})
	}

	const scrollToLocationHash = (behavior = 'auto') => {
		const target = findHashTarget(getHashId(window.location))
		if (!target) return
		scrollToTarget(target, behavior)
	}

	const resetAccordions = (root) => {
		root.querySelectorAll('.dw-menu__accordion').forEach((accordion) => {
			accordion.classList.remove('is-open')
			accordion.removeAttribute('open')
		})
	}

	const initAccordions = (root) => {
		root.querySelectorAll('.dw-menu__accordion').forEach((accordion) => {
			if (accordion.dataset.accordionInitialized === 'true') return

			const summary = accordion.querySelector(':scope > .dw-menu__summary')
			const content = accordion.querySelector(':scope > .dw-menu__content')
			if (!summary || !content) return

			accordion.dataset.accordionInitialized = 'true'

			summary.addEventListener('click', (event) => {
				event.preventDefault()

				if (accordion.classList.contains('is-open')) {
					accordion.classList.remove('is-open')
					content.addEventListener(
						'transitionend',
						(transitionEvent) => {
							if (transitionEvent.propertyName !== 'grid-template-rows') return
							accordion.open = false
						},
						{ once: true }
					)
					return
				}

				accordion.open = true
				requestAnimationFrame(() => {
					accordion.classList.add('is-open')
				})
			})
		})
	}

	const initDwSidebarMenu = () => {
		const menu = document.getElementById('dw-menu')
		if (!menu || menu.dataset.initialized === 'true') return

		const trigger = document.querySelector('.dw-menu__trigger')
		const panel = document.getElementById('dw-menu-panel')
		const closeBtn = menu.querySelector('.dw-menu__close')
		const backdrop = menu.querySelector('.dw-menu__backdrop')

		if (!trigger || !panel || !closeBtn || !backdrop) return

		if (menu.parentElement !== document.body) {
			document.body.appendChild(menu)
		}

		menu.dataset.initialized = 'true'
		initAccordions(menu)
		openCurrentAccordions(menu)
		let lastFocusedElement = null
		const mainContent = document.getElementById('MainContent')

		const close = ({ restoreFocus = true } = {}) => {
			menu.dataset.open = 'false'
			trigger.setAttribute('aria-expanded', 'false')
			panel.setAttribute('aria-hidden', 'true')
			document.body.classList.remove('dw-menu-open')
			mainContent?.removeAttribute('inert')

			resetAccordions(menu)

			if (!restoreFocus) return

			if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
				lastFocusedElement.focus()
			} else {
				trigger.focus()
			}
		}

		const open = () => {
			lastFocusedElement = document.activeElement
			openCurrentAccordions(menu)
			menu.dataset.open = 'true'
			trigger.setAttribute('aria-expanded', 'true')
			panel.setAttribute('aria-hidden', 'false')
			document.body.classList.add('dw-menu-open')
			mainContent?.setAttribute('inert', '')
			closeBtn.focus()
		}

		trigger.addEventListener('click', open)
		closeBtn.addEventListener('click', close)
		backdrop.addEventListener('click', close)

		panel.addEventListener('click', (event) => {
			const anchor = event.target.closest('a[href]')
			if (!anchor || !panel.contains(anchor)) return

			const url = parseHref(anchor.getAttribute('href'))
			const id = getHashId(url)
			if (!id || !isSamePage(url)) return

			const target = findHashTarget(id)
			if (!target) return

			event.preventDefault()
			close({ restoreFocus: false })
			history.pushState(null, '', `#${id}`)
			requestAnimationFrame(() => {
				scrollToTarget(target)
			})
		})

		if (!window.__dwMenuEscapeBound) {
			window.__dwMenuEscapeBound = true
			document.addEventListener('keydown', (event) => {
				const activeMenu = document.getElementById('dw-menu')
				if (event.key !== 'Escape' || activeMenu?.dataset.open !== 'true') return

				activeMenu.dataset.open = 'false'
				document.body.classList.remove('dw-menu-open')
				document.getElementById('MainContent')?.removeAttribute('inert')
				resetAccordions(activeMenu)
				document.querySelector('.dw-menu__trigger')?.focus()
			})
		}
	}

	initDwSidebarMenu()
	document.addEventListener('shopify:section:load', initDwSidebarMenu)

	if (!window.__dwHashScrollBound) {
		window.__dwHashScrollBound = true

		const onLoad = () => {
			requestAnimationFrame(() => {
				scrollToLocationHash('auto')
			})
		}

		if (document.readyState === 'complete') {
			onLoad()
		} else {
			window.addEventListener('load', onLoad, { once: true })
		}

		window.addEventListener('hashchange', () => {
			scrollToLocationHash('smooth')
		})
	}
})()
